import React, { useState, useEffect, useRef } from 'react';
import { getAuth } from 'firebase/auth';

// ============================================
// ADD THESE CONSTANTS AFTER IMPORTS
// ============================================
const AZURE_OPENAI_ENDPOINT = process.env.REACT_APP_AZURE_OPENAI_ENDPOINT || "https://SECURE_BACKEND.openai.azure.com";
const AZURE_OPENAI_KEY = process.env.REACT_APP_AZURE_OPENAI_KEY || "SECURE_BACKEND";
const AZURE_OPENAI_DEPLOYMENT = process.env.REACT_APP_AZURE_OPENAI_DEPLOYMENT || "SECURE_BACKEND";
const HUME_API_KEY = process.env.REACT_APP_HUME_API_KEY || 'SECURE_BACKEND';
const AZURE_SPEECH_API_KEY = "SECURE_BACKEND"; // Add your key
const AZURE_SPEECH_REGION = "eastus2"; 

// ============================================
// ADD VOICE CONFIGURATION
// ============================================
const VOICE_CONFIG = {
  emma: "33045fd9-8010-43f6-b6b0-da3fbf326c29",
  james: "41745808-6790-4be4-83db-363e20db7e71"
};

export default function SharedContentViewer({ sharedContent }) {
  const [showModal, setShowModal] = useState(false);
  const [gradient, setGradient] = useState(null);

  useEffect(() => {
    if (!sharedContent) return;
    
    const gradients = [
      { background: `url('/image/studycard7.png')`, backgroundSize: "cover", backgroundPosition: "center" },
      { background: `url('/image/studycard12.png')`, backgroundSize: "cover", backgroundPosition: "center" },
      { background: `url('/image/studycard13.png')`, backgroundSize: "cover", backgroundPosition: "center" },
      { background: `url('/image/studycard5.png')`, backgroundSize: "cover", backgroundPosition: "center" },
      { background: `url('/image/studycard15.png')`, backgroundSize: "cover", backgroundPosition: "center" },
    ];
    
    const randomGradient = gradients[Math.floor(Math.random() * gradients.length)];
    setGradient(randomGradient);
    
    setTimeout(() => setShowModal(true), 100);
  }, [sharedContent]);

  if (!sharedContent || !showModal) return null;

  return (
    <>
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        @keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { 
    opacity: 1; 
    transform: scale(1); 
  }
  50% { 
    opacity: 0.7; 
    transform: scale(0.95); 
  }
}
        body {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          background: #ffffff;
          overflow: hidden;
        }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 2000;
          display: flex;
          align-items: flex-end;
        }

        .quiz-modal {
          width: 100%;
          height: 90vh;
          background: linear-gradient(180deg, #f1f9ffff 0%, #b2d3ffff 100%);
          border-radius: 24px 24px 0 0;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          position: relative;
        }

        .quiz-modal::before {
          content: "";
          position: absolute;
          inset: 0;
          background: inherit;
          background-size: inherit;
          background-position: inherit;
          filter: blur(3px);
          transform: scale(1.1);
          z-index: 0;
        }

        .quiz-modal > * {
          position: relative;
          z-index: 1;
        }

        .modal-header {
          padding: 16px 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .modal-body {
          flex: 1;
          padding: 24px;
          padding-bottom: 100px;
          overflow-y: auto;
        }

        .question-card {
          background: rgba(255, 255, 255, 0.85);
          backdrop-filter: blur(20px);
          border-radius: 28px;
          padding: 24px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          border: 1px solid rgba(231, 231, 231, 1);
        }

        .options {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .option {
          padding: 14px 16px;
          background: white;
          border: 2px solid #e5e7eb;
          border-radius: 20px;
          cursor: pointer;
          font-size: 12px;
          color: #5e6166ff;
          text-align: left;
          font-weight: 400;
          transition: all 0.2s;
        }

        .option:hover:not(:disabled) { border-color: #3b82f6; }
        .option.selected { background: #dbeafe; border-color: #e8f1ffff; font-weight: 600; }
        .option.correct { background: #d1fae5; border-color: #10b981; }
        .option.wrong { background: #fee2e2; border-color: #ef4444; }
        .option:disabled { cursor: default; }

        .btn-next {
          width: 90%;
          padding: 10px;
          background: #f3f4f6;
          border: none;
          border-radius: 20px;
          cursor: not-allowed;
          margin-bottom: 20px;
          font-size: 13px;
          font-weight: 500;
          color: #9ca3af;
        }

        .btn-next.active {
          background: #272727;
          color: white;
          cursor: pointer;
        }

        .flashcard {
          flex: 1;
          background: rgba(255, 255, 255, 0.85);
          backdrop-filter: blur(20px);
          border-radius: 20px;
          padding: 32px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          min-height: 300px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          border: 1px solid rgba(231, 231, 231, 1);
        }

        .flashcard-text {
          font-size: 16px;
          font-weight: 500;
          color: #1f2937;
          text-align: center;
        }

        .tap-hint {
          font-size: 12px;
          color: #9ca3af;
          margin-top: 16px;
        }

        .flashcard-flip-container {
          perspective: 1000px;
          min-height: 300px;
          cursor: pointer;
        }

        .flashcard-flip-inner {
          position: relative;
          width: 100%;
          height: 100%;
          min-height: 300px;
          transition: transform 0.6s;
          transform-style: preserve-3d;
        }

        .flashcard-flip-container.flipped .flashcard-flip-inner {
          transform: rotateY(180deg);
        }

        .flashcard-front, .flashcard-back {
          position: absolute;
          width: 100%;
          height: 100%;
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
        }

        .flashcard-back {
          transform: rotateY(180deg);
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes slideIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes slideInCard {
          from { 
            opacity: 0;
            transform: translateY(30px) scale(0.95);
          }
          to { 
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        
        @keyframes slideInShadow {
          from { 
            opacity: 0;
            transform: translateX(-50%) translateY(20px);
          }
          to { 
            opacity: 0.6;
            transform: translateX(-50%) translateY(0);
          }
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }

        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>

      <div className="modal-overlay">
        {sharedContent.type === 'quiz' ? (
          <QuizView 
            quiz={sharedContent} 
            gradient={gradient}
          />
        ) : (
          <FlashcardView 
            flashcards={sharedContent} 
            gradient={gradient}
          />
        )}
      </div>
    </>
  );
}

function AIHelpComponent({ currentQuestion, contentType }) {
  const [aiMode, setAiMode] = useState(null); // null, 'choice', 'voice', 'chat'
  const [aiHostsStatus, setAiHostsStatus] = useState('idle');
  const [currentSpeaker, setCurrentSpeaker] = useState(null);
  const [hostMessage, setHostMessage] = useState('');
  const [transcript, setTranscript] = useState('');
  const [chatInput, setChatInput] = useState('');
  const [chatMessages, setChatMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  
  const recognitionRef = useRef(null);
  const currentAudioRef = useRef(null);
  const audioQueueRef = useRef(new Map());
  const isPreloadingRef = useRef(new Set());
  const conversationHistoryRef = useRef([]);

  // ============================================
  // SPEECH RECOGNITION SETUP
  // ============================================
  const initializeSpeechRecognition = async () => {
    try {
      if (typeof window.SpeechSDK === 'undefined') {
        throw new Error('Azure Speech SDK not loaded');
      }

      const SpeechSDK = window.SpeechSDK;
      const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
        AZURE_SPEECH_API_KEY,
        AZURE_SPEECH_REGION
      );

      speechConfig.speechRecognitionLanguage = "en-US";
      const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
      const recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);

      recognitionRef.current = recognizer;

      recognizer.recognizing = (s, e) => {
        if (e.result.reason === SpeechSDK.ResultReason.RecognizingSpeech) {
          setTranscript(e.result.text);
        }
      };

      recognizer.recognized = (s, e) => {
        if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
          const text = e.result.text;
          if (text && text.trim().length > 0) {
            handleUserInput(text.trim());
            setTranscript('');
          }
        }
      };

      return recognizer;
    } catch (error) {
      console.error('Speech recognition error:', error);
      throw error;
    }
  };

  // ============================================
  // TTS WITH HUME
  // ============================================
  const speakWithHumeStreaming = async (text, host) => {
    return new Promise(async (resolve) => {
      try {
        setAiHostsStatus('speaking');
        setCurrentSpeaker(host);
        setHostMessage(text);

        const response = await fetch('https://api.hume.ai/v0/tts/stream/file', {
          method: 'POST',
          headers: {
            'X-Hume-Api-Key': HUME_API_KEY,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            utterances: [{
              text: text,
              voice: { provider: 'HUME_AI', id: VOICE_CONFIG[host] }
            }],
            format: { type: 'mp3', sample_rate: 15000 },
            instant_mode: true,
            strip_headers: true,
            version: "2"
          })
        });

        if (!response.ok) throw new Error(`TTS failed: ${response.status}`);

        const reader = response.body.getReader();
        const chunks = [];

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          chunks.push(value);
        }

        const blob = new Blob(chunks, { type: 'audio/mpeg' });
        const url = URL.createObjectURL(blob);
        const audio = new Audio(url);
        audio.playbackRate = 1.1;

        if (currentAudioRef.current) {
          currentAudioRef.current.pause();
          currentAudioRef.current = null;
        }

        currentAudioRef.current = audio;

        audio.onended = () => {
          URL.revokeObjectURL(url);
          currentAudioRef.current = null;
          setAiHostsStatus('listening');
          resolve();
        };

        audio.onerror = () => {
          URL.revokeObjectURL(url);
          currentAudioRef.current = null;
          resolve();
        };

        await audio.play();
      } catch (error) {
        console.error('TTS Error:', error);
        resolve();
      }
    });
  };

  // ============================================
  // VOICE MODE HANDLER
  // ============================================
  const startAIHosts = async () => {
    setAiHostsStatus('loading');
    
    try {
      const recognizer = await initializeSpeechRecognition();
      
      if (recognizer?.startContinuousRecognitionAsync) {
        recognizer.startContinuousRecognitionAsync(
          () => {
            console.log('✅ Voice recognition started');
            setAiHostsStatus('listening');
          },
          (error) => {
            console.error('❌ Failed to start:', error);
            alert(`Microphone error: ${error}`);
          }
        );
      }
    } catch (error) {
      console.error('Voice initialization error:', error);
      alert('Failed to start voice mode. Please check microphone permissions.');
      setAiMode(null);
    }

    await new Promise(resolve => setTimeout(resolve, 800));
    
    const greeting = `Hey! I'm here to help you with this ${contentType === 'quiz' ? 'quiz question' : 'flashcard'}. What do you need help with?`;
    await speakWithHumeStreaming(greeting, 'emma');
  };

  const stopAIHosts = () => {
    try {
      if (recognitionRef.current?.stopContinuousRecognitionAsync) {
        recognitionRef.current.stopContinuousRecognitionAsync();
      }
    } catch (e) {
      console.log('Stop error:', e.message);
    }

    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current = null;
    }

    setAiMode(null);
    setAiHostsStatus('idle');
    setTranscript('');
    setHostMessage('');
    setCurrentSpeaker(null);
  };

  const handleUserInput = async (text) => {
    if (!text.trim() || aiHostsStatus === 'thinking') return;

    setAiHostsStatus('thinking');
    setTranscript('');

    try {
      if (recognitionRef.current?.stopContinuousRecognitionAsync) {
        recognitionRef.current.stopContinuousRecognitionAsync();
      }
    } catch (e) {
      console.log('Stop error:', e);
    }

    conversationHistoryRef.current.push({
      role: 'user',
      content: text
    });

    try {
      const context = contentType === 'quiz'
        ? `Question: "${currentQuestion.question}"\nOptions: ${currentQuestion.options?.join(', ') || 'True/False'}\nCorrect Answer: ${currentQuestion.correctAnswer}`
        : `Flashcard Front: "${currentQuestion.question}"\nFlashcard Back: "${currentQuestion.answer}"`;

      const systemPrompt = `You are Emma, a friendly AI tutor helping a student.

${context}

Student said: "${text}"

Respond naturally in 2-3 SHORT sentences. Guide them without giving away answers directly.`;

      const response = await fetch(
        `${AZURE_OPENAI_ENDPOINT}/openai/deployments/${AZURE_OPENAI_DEPLOYMENT}/chat/completions?api-version=2024-02-15-preview`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'api-key': AZURE_OPENAI_KEY
          },
          body: JSON.stringify({
            messages: [
              { role: 'system', content: systemPrompt },
              ...conversationHistoryRef.current.slice(-6)
            ],
            temperature: 0.8,
            max_tokens: 150
          })
        }
      );

      const data = await response.json();
      const aiResponse = data.choices[0].message.content;

      conversationHistoryRef.current.push({
        role: 'assistant',
        content: aiResponse
      });

      await speakWithHumeStreaming(aiResponse, 'emma');

      // Restart recognition
      try {
        if (recognitionRef.current?.startContinuousRecognitionAsync) {
          recognitionRef.current.startContinuousRecognitionAsync();
        }
      } catch (e) {
        console.log('Restart error:', e);
      }

    } catch (error) {
      console.error('AI Error:', error);
      setAiHostsStatus('listening');
    }
  };

  // ============================================
  // TEXT CHAT HANDLER
  // ============================================
  const handleTextChatSend = async () => {
    if (!chatInput.trim() || isLoading) return;

    const userMessage = chatInput;
    setChatMessages(prev => [...prev, { role: 'user', content: userMessage }]);
    setChatInput('');
    setIsLoading(true);

    try {
      const context = contentType === 'quiz'
        ? `Question: "${currentQuestion.question}"\nOptions: ${currentQuestion.options?.join(', ') || 'True/False'}\nCorrect Answer: ${currentQuestion.correctAnswer}`
        : `Flashcard Front: "${currentQuestion.question}"\nFlashcard Back: "${currentQuestion.answer}"`;

      const systemPrompt = `You are Emma, a helpful tutor. The student needs help with this:

${context}

Student asked: "${userMessage}"

Provide a SHORT (2-3 sentences) helpful response. Guide them without giving away the answer directly.`;

      const response = await fetch(
        `${AZURE_OPENAI_ENDPOINT}/openai/deployments/${AZURE_OPENAI_DEPLOYMENT}/chat/completions?api-version=2024-02-15-preview`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'api-key': AZURE_OPENAI_KEY
          },
          body: JSON.stringify({
            messages: [
              { role: 'system', content: systemPrompt },
              { role: 'user', content: userMessage }
            ],
            temperature: 0.8,
            max_tokens: 150
          })
        }
      );

      const data = await response.json();
      const aiResponse = data.choices[0].message.content;

      setChatMessages(prev => [...prev, { role: 'assistant', content: aiResponse }]);
    } catch (error) {
      console.error('Chat error:', error);
      setChatMessages(prev => [...prev, { 
        role: 'assistant', 
        content: 'Sorry, I had trouble with that. Try asking again!' 
      }]);
    } finally {
      setIsLoading(false);
    }
  };

  // ============================================
  // RENDER FUNCTIONS
  // ============================================
  const renderAskButton = () => (
    <button
      onClick={() => setAiMode('choice')}
      style={{
        marginTop: '20px',
        width: 'fit-content',
        padding: '12px 24px',
        background: '#000000',
        border: 'none',
        borderRadius: '24px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        margin: '20px auto 0',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        transition: 'all 0.2s',
        animation: 'slideUp 0.4s ease-out'
      }}
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
        <path stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9v3a5.006 5.006 0 0 1-5 5h-4a5.006 5.006 0 0 1-5-5V9m7 9v3m-3 0h6M11 3h2a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Z"/>
      </svg>
      <span style={{ fontSize: '13px', fontWeight: '500', color: 'white' }}>
        Ask Preptune
      </span>
    </button>
  );

  const renderChoiceModal = () => (
    <div style={{ marginTop: '20px', animation: 'slideUp 0.4s ease-out' }}>
      <div style={{
        background: 'white',
        borderRadius: '28px',
        padding: '18px',
        border: '1px solid #e5e7eb',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
      }}>
        <div style={{
          fontSize: '13px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '16px',
          textAlign: 'center'
        }}>
          Pick One
        </div>

        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={() => setAiMode('chat')}
            style={{
              flex: 1,
              padding: '10px',
              background: '#e5e7eb',
              border: 'none',
              borderRadius: '24px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: '600',
              color: '#374151',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
          >
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M12.5 3L2.5 3.00002C1.67157 3.00002 1 3.6716 1 4.50002V9.50003C1 10.3285 1.67157 11 2.5 11H7.50003C7.63264 11 7.75982 11.0527 7.85358 11.1465L10 13.2929V11.5C10 11.2239 10.2239 11 10.5 11H12.5C13.3284 11 14 10.3285 14 9.50003V4.5C14 3.67157 13.3284 3 12.5 3Z" fill="currentColor"/>
            </svg>
            Use Chat
          </button>

          <button
            onClick={() => {
              setAiMode('voice');
              startAIHosts();
            }}
            style={{
              flex: 1,
              padding: '10px',
              background: '#000000',
              border: 'none',
              borderRadius: '24px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: '600',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
              <path stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9v3a5.006 5.006 0 0 1-5 5h-4a5.006 5.006 0 0 1-5-5V9m7 9v3m-3 0h6M11 3h2a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Z"/>
            </svg>
            Use Voice
          </button>
        </div>
      </div>
    </div>
  );

  const renderVoiceMode = () => {
    const getStatusDisplay = () => {
      switch (aiHostsStatus) {
        case 'loading':
          return {
            text: 'Loading',
            icon: (
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                borderTop: '2px solid white',
                borderRadius: '50%',
                animation: 'spin 0.8s linear infinite'
              }} />
            )
          };
        case 'listening':
          return {
            text: 'Listening',
            icon: (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ animation: 'pulse 1.5s infinite' }}>
                <path stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9v3a5.006 5.006 0 0 1-5 5h-4a5.006 5.006 0 0 1-5-5V9m7 9v3m-3 0h6M11 3h2a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Z"/>
              </svg>
            )
          };
        case 'thinking':
          return {
            text: 'Thinking',
            icon: (
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                borderTop: '2px solid white',
                borderRadius: '50%',
                animation: 'spin 0.8s linear infinite'
              }} />
            )
          };
        case 'speaking':
          return {
            text: 'Emma speaking',
            icon: (
              <div style={{
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                background: 'white',
                animation: 'pulse 1s infinite'
              }} />
            )
          };
        default:
          return { text: 'Active', icon: null };
      }
    };

    const status = getStatusDisplay();

    return (
      <div style={{ marginTop: '20px' }}>
        <div style={{
          width: '100%',
          padding: '12px',
          background: '#000000',
          borderRadius: '20px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            position: 'relative'
          }}>
            {status.icon}
            <span style={{ fontSize: '13px', fontWeight: '500', color: 'white' }}>
              {status.text}
            </span>

            <button
              onClick={stopAIHosts}
              style={{
                position: 'absolute',
                right: '0',
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.15)',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <svg width="12" height="12" viewBox="0 0 15 15" fill="none">
                <path d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="white"/>
              </svg>
            </button>
          </div>

          {transcript && aiHostsStatus === 'listening' && (
            <div style={{
              marginTop: '12px',
              padding: '10px 12px',
              background: 'rgba(255, 255, 255, 0.1)',
              border: '1px dashed rgba(255, 255, 255, 0.3)',
              borderRadius: '10px',
              fontSize: '11px',
              color: 'rgba(255, 255, 255, 0.9)',
              fontStyle: 'italic',
              textAlign: 'left'
            }}>
              <div style={{
                fontSize: '9px',
                fontWeight: '600',
                color: 'rgba(255, 255, 255, 0.7)',
                marginBottom: '4px',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                YOU'RE SAYING:
              </div>
              "{transcript}"
            </div>
          )}

          {hostMessage && aiHostsStatus === 'speaking' && (
            <div style={{
              marginTop: '12px',
              padding: '10px 12px',
              background: 'rgba(255, 255, 255, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '10px',
              textAlign: 'left'
            }}>
              <div style={{
                fontSize: '9px',
                fontWeight: '600',
                color: 'rgba(255, 255, 255, 0.7)',
                marginBottom: '6px',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                EMMA
              </div>
              <div style={{
                fontSize: '12px',
                color: 'white',
                lineHeight: '1.5'
              }}>
                {hostMessage}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderTextChat = () => (
    <div style={{ marginTop: '20px', animation: 'slideUp 0.4s ease-out' }}>
      <div style={{
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        background: 'rgba(255, 255, 255, 0.15)',
        border: '1px solid rgba(255, 255, 255, 0.41)',
        backdropFilter: 'blur(12px)',
        borderRadius: '24px',
        padding: '8px 12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
      }}>
        <input
          type="text"
          value={chatInput}
          onChange={(e) => setChatInput(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleTextChatSend()}
          placeholder="Ask Emma..."
          disabled={isLoading}
          style={{
            flex: 1,
            border: 'none',
            borderRadius: '16px',
            padding: '10px 12px',
            fontSize: '12px',
            outline: 'none',
            background: 'white',
            color: '#1f2937'
          }}
        />

        <button
          onClick={() => setAiMode(null)}
          style={{
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            background: '#ffffff',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#000000" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <button
          onClick={handleTextChatSend}
          disabled={!chatInput.trim() || isLoading}
          style={{
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            background: (!chatInput.trim() || isLoading) ? '#8b8b8b' : '#000000',
            border: 'none',
            cursor: (!chatInput.trim() || isLoading) ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            flexShrink: 0
          }}
        >
          {isLoading ? (
            <div style={{
              width: '14px',
              height: '14px',
              border: '2px solid rgba(255, 255, 255, 0.3)',
              borderTop: '2px solid white',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite'
            }} />
          ) : (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="m5 12 7-7 7 7M12 19V5" />
            </svg>
          )}
        </button>
      </div>

      {chatMessages.length > 0 && (
        <div style={{
          marginTop: '12px',
          maxHeight: '200px',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px'
        }}>
          {chatMessages.map((msg, idx) => (
            <div
              key={idx}
              style={{
                padding: '10px 14px',
                borderRadius: '16px',
                fontSize: '12px',
                lineHeight: '1.5',
                background: msg.role === 'user' ? '#f2f2f2' : 'white',
                color: 'black',
                border: msg.role === 'assistant' ? '1px solid #e5e7eb' : 'none',
                textAlign: 'left',
                animation: 'fadeIn 0.3s ease-out'
              }}
            >
              {msg.content}
            </div>
          ))}
        </div>
      )}
    </div>
  );

  // ============================================
  // MAIN RENDER
  // ============================================
  if (!aiMode) return renderAskButton();
  if (aiMode === 'choice') return renderChoiceModal();
  if (aiMode === 'voice') return renderVoiceMode();
  if (aiMode === 'chat') return renderTextChat();

  return null;
}
// ============================================
// QUIZ VIEW COMPONENT
// ============================================
function QuizView({ quiz, gradient }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState({});
  const [showExplanation, setShowExplanation] = useState(false);
  const [showResults, setShowResults] = useState(false);

  const questions = quiz.questions || [];
  const currentQuestion = questions[currentIndex];
  const hasAnswered = userAnswers[currentQuestion?.id] !== undefined;
  const progressPercentage = ((currentIndex + 1) / questions.length) * 100;

  const handleAnswer = (answer) => {
    const normalizedAnswer = typeof answer === 'string' ? answer.toLowerCase() : answer;
    setUserAnswers(prev => ({ ...prev, [currentQuestion.id]: normalizedAnswer }));
    setShowExplanation(true);
  };

  const handleNext = () => {
    if (currentIndex < questions.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setShowExplanation(false);
    } else {
      setShowResults(true);
    }
  };

  const handleRestart = () => {
    setShowResults(false);
    setCurrentIndex(0);
    setUserAnswers({});
    setShowExplanation(false);
  };

  const calculateScore = () => {
    let correct = 0;
    questions.forEach(q => {
      const userAnswer = userAnswers[q.id];
      let correctAnswer = q.correctAnswer;
      
      if (q.type === 'true_false') {
        correctAnswer = correctAnswer?.toString().toLowerCase();
        if (userAnswer?.toLowerCase() === correctAnswer) correct++;
      } else {
        if (userAnswer === correctAnswer) correct++;
      }
    });
    return correct;
  };

  if (showResults) {
    const score = calculateScore();
    const percentage = Math.round((score / questions.length) * 100);

    return (
      <div className="quiz-modal" style={gradient}>
        <div className="modal-header">
          <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937' }}>
            Quiz Complete
          </div>
        </div>

        <div className="modal-body" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '52px', fontWeight: '800', color: percentage >= 70 ? '#10b981' : '#f59e0b', marginBottom: '8px' }}>
              {percentage}%
            </div>
            <div style={{ fontSize: '16px', fontWeight: '600', color: percentage >= 70 ? '#10b981' : '#f59e0b', marginBottom: '12px' }}>
              {percentage >= 90 ? 'Outstanding! 🌟' : percentage >= 70 ? 'Great job! 🎉' : 'Keep practicing! 📚'}
            </div>
            <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '24px' }}>
              {score} / {questions.length} correct
            </p>
            <button 
              onClick={handleRestart}
              style={{
                padding: '12px 32px',
                background: '#272727',
                border: 'none',
                borderRadius: '20px',
                color: 'white',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Start Over
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="quiz-modal" style={gradient}>
      <div className="modal-header">
        <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937' }}>
          Question {currentIndex + 1} / {questions.length}
        </div>
      </div>

      <div style={{ padding: '0 20px', marginBottom: '10px' }}>
        <div style={{ width: '80%', height: '3px', background: 'rgba(255, 255, 255, 0.6)', borderRadius: '20px', margin: '0 auto', overflow: 'hidden' }}>
          <div style={{ width: `${progressPercentage}%`, height: '100%', background: '#000000', transition: 'width 0.3s ease', borderRadius: '20px' }}></div>
        </div>
      </div>

      <div className="modal-body">
        <div style={{ position: 'relative', width: '100%', animation: 'slideIn 0.3s ease-out' }}>
          {(() => {
            const remainingQuestions = questions.length - currentIndex - 1;
return (
  <>
    {/* Second shadow card */}
    {remainingQuestions >= 2 && (
      <div style={{
        position: 'absolute',
        top: '16px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '90%',
        height: '100%',
        background: 'white',
        opacity: '0.4',
        borderRadius: '24px',
        border: '1px solid rgba(0, 0, 0, 0.06)',
        zIndex: 0,
        pointerEvents: 'none',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.08)'
      }} />
    )}
    
    {/* First shadow card */}
    {remainingQuestions >= 1 && (
      <div style={{
        position: 'absolute',
        top: '8px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '95%',
        height: '100%',
        background: 'white',
        opacity: '0.6',
        borderRadius: '24px',
        border: '1px solid rgba(0, 0, 0, 0.08)',
        zIndex: 1,
        pointerEvents: 'none',
        boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)'
      }} />
    )}
  </>
);
})()}

          {/* Main question card */}
          <div 
            className="question-card"
            style={{ 
              position: 'relative', 
              zIndex: 2,
              marginBottom: '24px'
            }}
          >
            <h3 style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937', marginBottom: '20px' }}>
              {currentQuestion.question}
            </h3>

            <div className="options">
              {currentQuestion.type === 'multiple_choice' ? (
                currentQuestion.options.map((option, idx) => {
                  const isSelected = userAnswers[currentQuestion.id] === option;
                  const isCorrect = hasAnswered && option === currentQuestion.correctAnswer;
                  const isWrong = hasAnswered && isSelected && option !== currentQuestion.correctAnswer;

                  return (
                    <button
                      key={idx}
                      onClick={() => !hasAnswered && handleAnswer(option)}
                      disabled={hasAnswered}
                      className={`option ${isCorrect ? 'correct' : ''} ${isWrong ? 'wrong' : ''} ${isSelected && !hasAnswered ? 'selected' : ''}`}
                    >
                      {option}
                    </button>
                  );
                })
              ) : (
                ['True', 'False'].map((option) => {
                  const optionValue = option.toLowerCase();
                  const isSelected = userAnswers[currentQuestion.id] === optionValue;
                  const correctAnswerLower = currentQuestion.correctAnswer?.toString().toLowerCase();
                  const isCorrect = hasAnswered && optionValue === correctAnswerLower;
                  const isWrong = hasAnswered && isSelected && optionValue !== correctAnswerLower;

                  return (
                    <button
                      key={option}
                      onClick={() => !hasAnswered && handleAnswer(optionValue)}
                      disabled={hasAnswered}
                      className={`option ${isCorrect ? 'correct' : ''} ${isWrong ? 'wrong' : ''} ${isSelected && !hasAnswered ? 'selected' : ''}`}
                    >
                      {option}
                    </button>
                  );
                })
              )}
            </div>

            {showExplanation && hasAnswered && currentQuestion.explanation && (
              <div style={{
                marginTop: '20px',
                padding: '16px',
                background: userAnswers[currentQuestion.id]?.toLowerCase() === currentQuestion.correctAnswer?.toString().toLowerCase() ? '#d1fae5' : '#fee2e2',
                borderRadius: '16px',
                fontSize: '12px',
                color: '#1f2937',
                lineHeight: '1.6',
                textAlign: 'left',
                animation: 'fadeIn 0.4s ease-out'
              }}>
                <div style={{ fontWeight: '500', marginBottom: '6px' }}>
                  {userAnswers[currentQuestion.id]?.toLowerCase() === currentQuestion.correctAnswer?.toString().toLowerCase() ? '✓ Correct!' : '✗ Incorrect'}
                </div>
                {currentQuestion.explanation}
              </div>
            )}

            <button 
              onClick={handleNext}
              disabled={!hasAnswered || showResults}
              className={`btn-next ${hasAnswered && !showResults ? 'active' : ''}`}
              style={{ marginTop: '24px', transition: 'all 0.3s ease' }}
            >
              {currentIndex === questions.length - 1 ? 'Finish' : 'Next'}
            </button>
          </div>
        </div>

        {/* AI Help Component */}
        <AIHelpComponent 
          currentQuestion={currentQuestion}
          contentType="quiz"
        />
      </div>
    </div>
  );
}

// ============================================
// FLASHCARD VIEW COMPONENT
// ============================================
function FlashcardView({ flashcards, gradient }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);
  const [showCompletion, setShowCompletion] = useState(false);

  const cards = flashcards.flashcards || [];
  const currentCard = cards[currentIndex];
  const progressPercentage = ((currentIndex + 1) / cards.length) * 100;

  const handleFlip = () => setIsFlipped(!isFlipped);

  const handleNext = () => {
    if (currentIndex < cards.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setIsFlipped(false);
    } else {
      setShowCompletion(true);
    }
  };

  const handleRestart = () => {
    setShowCompletion(false);
    setCurrentIndex(0);
    setIsFlipped(false);
  };

  if (showCompletion) {
    return (
      <div className="quiz-modal" style={gradient}>
        <div className="modal-header">
          <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937' }}>
            Session Complete
          </div>
        </div>

        <div className="modal-body" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '42px', marginBottom: '16px' }}>🎉</div>
            <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1f2937', marginBottom: '8px' }}>
              Session Complete!
            </h3>
            <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '24px' }}>
              You studied {cards.length} cards
            </p>
            <button 
              onClick={handleRestart}
              style={{
                padding: '12px 32px',
                background: '#272727',
                border: 'none',
                borderRadius: '20px',
                color: 'white',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Start Over
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="quiz-modal" style={gradient}>
      <div className="modal-header">
        <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937' }}>
          Card {currentIndex + 1} / {cards.length}
        </div>
      </div>

      <div style={{ padding: '0 20px', marginBottom: '10px' }}>
        <div style={{ width: '80%', height: '3px', background: 'rgba(255, 255, 255, 0.6)', borderRadius: '20px', margin: '0 auto', overflow: 'hidden' }}>
          <div style={{ width: `${progressPercentage}%`, height: '100%', background: '#000000', transition: 'width 0.3s ease', borderRadius: '20px' }}></div>
        </div>
      </div>

      <div className="modal-body">
        <div style={{ position: 'relative', width: '100%', marginBottom: '24px' }}>
          {(() => {
            const remainingCards = cards.length - currentIndex - 1;
            
            return (
              <>
                {remainingCards >= 2 && (
                  <div style={{
                    position: 'absolute',
                    top: '16px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '90%',
                    height: '100%',
                    background: 'white',
                    opacity: '0.4',
                    borderRadius: '24px',
                    border: '1px solid rgba(0, 0, 0, 0.06)',
                    zIndex: 0,
                    pointerEvents: 'none',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.08)',
                    animation: 'slideInShadow 0.4s ease-out'
                  }} />
                )}
                
                {remainingCards >= 1 && (
                  <div style={{
                    position: 'absolute',
                    top: '8px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '95%',
                    height: '100%',
                    background: 'white',
                    opacity: '0.6',
                    borderRadius: '24px',
                    border: '1px solid rgba(0, 0, 0, 0.08)',
                    zIndex: 1,
                    pointerEvents: 'none',
                    boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)',
                    animation: 'slideInShadow 0.3s ease-out'
                  }} />
                )}
              </>
            );
          })()}

          <div 
            key={currentIndex}
            className={`flashcard-flip-container ${isFlipped ? 'flipped' : ''}`} 
            onClick={handleFlip}
            style={{ 
              position: 'relative', 
              zIndex: 2,
              boxShadow: '0 8px 20px rgba(0, 0, 0, 0.12)',
              borderRadius: '28px',
              animation: 'slideInCard 0.4s ease-out'
            }}
          >
            <div className="flashcard-flip-inner">
              <div className="flashcard flashcard-front">
                <div className="flashcard-text">{currentCard.question}</div>
                <div className="tap-hint">Tap to reveal answer</div>
              </div>
              <div className="flashcard flashcard-back">
                <div className="flashcard-text">{currentCard.answer}</div>
                <div className="tap-hint">Tap to see question</div>
              </div>
            </div>
          </div>
        </div>

        <button 
          onClick={handleNext}
          className="btn-next active"
          style={{ marginTop: '24px', transition: 'all 0.3s ease' }}
        >
          {currentIndex === cards.length - 1 ? 'Finish' : 'Next'}
        </button>

        {/* AI Help Component */}
        <AIHelpComponent 
          currentQuestion={currentCard}
          contentType="flashcard"
        />
      </div>
    </div>
  );
}